import React, { useState } from "react";
import { Card, ImageViewer } from 'antd-mobile';
import "./style.less";

const ListRecordView = (props) => {
  const { record } = props

  const [images, setImages] = useState([])
  const [imagesVisible, setImagesVisible] = useState(false)

  // 点击显示图片
  const handleClickCard = () => {
    if (record.images?.length > 0) {
      setImages(record.images)
      setImagesVisible(true)
    }
  }


  if (!record) {
    return undefined
  }

  return (
    <div className="record-view-wrapper">
      <Card onClick={handleClickCard}>
        <p>姓名：{record.name}</p>
        <p>电话：{record.mobile}</p>
        <p>时间：{record.reportTime}</p>
        <p>地点：{record.address}</p>
        <p>内容：{record.content}</p>
        {
          record.images?.length > 0 ?
            <p><a>点击查看图片</a></p>
            :
            undefined
        }
      </Card>

      <ImageViewer.Multi
        images={images}
        visible={imagesVisible}
        defaultIndex={0}
        onClose={() => {
          setImagesVisible(false)
        }}
      />
    </div>
  )
}

export default ListRecordView